import styled from "styled-components";
export const DPwrapper = styled.div`
    input {
        width: 100%;
        height: 3rem;
        border: 0.063rem solid #949494;
        border-radius: 3.438rem;
        font-size: 1rem;
        padding: 0 0.938rem;
        background-size: 1.25rem;
    }

    i {
        color: #000;
        position: absolute;
        z-index: 1;
        right: 15px;
        top: 13px;
        font-size: 20px;
        line-height: 20px;
        pointer-events: none;
    }

    .bookingPopper {
        z-index: 2;
        .react-datepicker__triangle {
            &::after {
                border-bottom-color: #fff;
            }
        }
    }

    .bookingDates {
        font-family: ${({ theme }) => theme.font};
        padding: 1.5rem 1.375rem;
        .react-datepicker__header {
            background: #fff;
            border: 0;
        }
        .react-datepicker__week, .react-datepicker__day-names {
            display: flex;
        }

        .react-datepicker__day-names {
            margin: 0.4rem;
        }

        .react-datepicker__day, .react-datepicker__day-name {
            display: flex;
            width: 2.75rem;
            height: 2.75rem;
            align-items: center;
            justify-content: center;
            background: transparent;
            border: 0.063rem solid #E0E0E0;
            color: #000;
            font-weight: 700;
            font-size: 1.125rem;

            &--selected {
                color: #fff;
                border-radius: 0;
                background: ${({ theme }) => theme.colors.primary};
                border: 0.063rem solid ${({ theme }) => theme.colors.primary};
            }

            &--disabled {
                color: #949494;
            }
        }

        .react-datepicker__day-name {
            border-color: #fff;
        }

        .react-datepicker__navigation {
            margin: 1.5rem 1.375rem;
            &-icon::before {
                border-color: #000;
            }
        }

        .react-datepicker__current-month {
            font-size: 1.25rem;
        }
    }
`;
